import React, { useCallback } from "react";
import { makeStyles } from "tss-react/mui";
import { IconArrowDown } from "../../../icons/svg";
const useStyles = makeStyles()((theme) => {
    return {
        actionButton: {
            ...theme.typography.bodyLongBold,
            borderRadius: "90px",
            boxSizing: "border-box",
            color: theme.palette.text01,
            cursor: "pointer",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "52px",
            marginBottom: "10px",
            position: "relative",
            textAlign: "center",
            width: "100%",
            border: 0,
            whiteSpace: "nowrap",
            fontSize: "0.9rem",
            "&.primary": {
                background: "#0063E4",
                color: theme.palette.text01,
                width: "240px",
                "&:hover": {
                    backgroundColor: theme.palette.action01Hover,
                },
            },
            "&.secondary": {
                background: theme.palette.action02,
                color: theme.palette.text04,
                "&:hover": {
                    backgroundColor: theme.palette.action02Hover,
                },
            },
            "&.text": {
                width: "auto",
                fontSize: "0.875rem",
                margin: "0",
                padding: "0",
            },
            "&.disabled": {
                background: theme.palette.disabled01,
                border: "1px solid #5E6D7A",
                color: "#AFB6BC",
                cursor: "initial",
                ".icon": {
                    "& > svg": {
                        fill: "#AFB6BC",
                    },
                },
            },
            [theme.breakpoints.down(768)]: {
                fontSize: "0.875rem",
                marginBottom: 6,
                padding: "12px 24px",
            },
        },
        options: {
            borderRadius: "6px",
            alignItems: "center",
            display: "flex",
            height: "100%",
            justifyContent: "center",
            position: "absolute",
            right: 0,
            top: 0,
            width: 36,
            // "&:hover": {
            //     backgroundColor: "#0262B6",
            // },
            "& svg": {
                pointerEvents: "none",
            },
        },
    };
});
/**
 * Button used for pre meeting actions.
 *
 * @returns {ReactElement}
 */
function ActionButton({ children, className = "", disabled, hasOptions, OptionsIcon = IconArrowDown, testId, type = "primary", onClick, onOptionsClick, tabIndex, role, ariaPressed, ariaLabel, ariaDropDownLabel, }) {
    const { classes, cx } = useStyles();
    const onKeyPressHandler = useCallback((e) => {
        if (onClick && !disabled && (e.key === " " || e.key === "Enter")) {
            e.preventDefault();
            onClick(e);
        }
    }, [onClick, disabled]);
    const onOptionsKeyPressHandler = useCallback((e) => {
        if (onOptionsClick && !disabled && (e.key === " " || e.key === "Enter")) {
            e.preventDefault();
            e.stopPropagation();
            onOptionsClick(e);
        }
    }, [onOptionsClick, disabled]);
    const containerClasses = cx(classes.actionButton, className && className, type, disabled && "disabled");
    return (React.createElement("div", { "aria-disabled": disabled, "aria-label": ariaLabel, className: containerClasses, "data-testid": testId ? testId : undefined, onClick: disabled ? undefined : onClick, onKeyPress: onKeyPressHandler, role: "button", tabIndex: 0 }, children));
}
export default ActionButton;
